import { ComponentProps, FunctionComponent } from "react";

import { LinkedinPremiumInvite } from "../LinkedinPremiumInvite";
import { LinkedinStandardInvite } from "../LinkedinStandardInvite";
import { InviteAlreadyConnectedToggle } from "./InviteAlreadyConnectedToggle";

/**
 * The "Send LinkedIn Invite" step's panel, the same in both builders (CampaignPage and
 * CampaignMessagingOverview): the already-connected switch (PREC-4426) above the two note editors.
 * One component, so the two panels cannot drift apart.
 */
export const LinkedinInviteStepPanel: FunctionComponent<
	ComponentProps<typeof LinkedinPremiumInvite>
> = (props) => (
	<>
		<InviteAlreadyConnectedToggle
			nodesRef={props.nodesRef}
			selectedNode={props.selectedNode}
			setIsDirty={props.setIsDirty}
			setSelectedNode={props.setSelectedNode}
			onUpdate={props.onUpdate}
		/>
		<LinkedinPremiumInvite {...props} />
		<LinkedinStandardInvite {...props} />
	</>
);
